export enum ArtifactFileKind {
  DEFAULT = 'default',
  PDF = 'pdf',
  DOCUMENT = 'document',
  IMAGE = 'image',
  SPREADSHEET = 'spreadsheet',
  TEXT = 'text',
}

export interface ArtifactItem {
  id: string;
  name: string;
  kind?: ArtifactFileKind;
  owner?: string;
  uploadedAt?: string;
}

export interface ArtifactsUploadAffordanceProps {
  title?: string;
  description?: string;
}

export interface ArtifactsProps {
  items?: ArtifactItem[];
  uploadAffordanceProps?: ArtifactsUploadAffordanceProps;
}
